import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/chats/:chatId/details",
	lazy(() => import("./AdminChatsDetailsPage"))
);
